import { DynamicStore } from '@as-react/common-utils';
import { generateHistoryObject } from '../utils/browser.util';
export const getStoreAndRouterHistory = async (scene, renderData, redux) => {
    if (!scene.hasReduxModule || !redux) {
        return;
    }
    const { storeConfigurator, dynamicStore } = redux;
    const dynamicStoreInstance = scene.reduxStorePerInstance ? new DynamicStore() : dynamicStore;
    const componentReduxModule = await storeConfigurator.loadFromModuleCollection(scene.componentName, renderData.store ?? {});
    const routerHistory = componentReduxModule.hasRouter ? generateHistoryObject() : undefined;
    const store = storeConfigurator.buildDynamic(renderData.store ?? {}, renderData.context, dynamicStoreInstance, componentReduxModule.modules, routerHistory);
    return {
        store,
        routerHistory,
    };
};
